import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './LoginPage.css';

// Email sign-up is closed server-side (bot rings were mass-creating accounts —
// 403 on POST /auth0/signup; see api/auth/email-signup-gate.js). New accounts:
// Google/Apple OAuth (provider-verified) or the voice AI sign-up. Email LOGIN
// for existing accounts is unchanged (/login).
const SignupPage = ({ onSignupSuccess }) => {
  const [appleEnabled, setAppleEnabled] = useState(false);

  // Show "Continue with Apple" only once the server has Apple OAuth configured.
  React.useEffect(() => {
    fetch('/api/apple/enabled')
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d && d.enabled) setAppleEnabled(true); })
      .catch(() => {});
  }, []);

  const handleGoogleSignup = () => {
    window.location.href = '/auth/google';
  };

  const handleAppleSignup = () => {
    window.location.href = '/auth/apple';
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <img src="/assets/dynamic/NumFreeSymbol.png" className="login-logo" alt="" />
          <h2>Create your account</h2>
          <p className="login-tagline">Get a real number, an AI assistant, and your message center in one place.</p>
        </div>

        <div className="login-error" data-testid="signup-email-closed" style={{ display: 'block' }}>
          Email sign-up is paused. Continue with Google{appleEnabled ? ' or Apple' : ''} below —
          or sign in if you already have an account.
        </div>

        <button
          className="login-google-btn"
          data-testid="signup-google"
          type="button"
          onClick={handleGoogleSignup}
        >
          <svg width="18" height="18" viewBox="0 0 24 24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
          Continue with Google
        </button>

        {appleEnabled && (
          <button
            className="login-apple-btn"
            data-testid="signup-apple"
            type="button"
            onClick={handleAppleSignup}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.05 12.04c-.03-2.6 2.12-3.85 2.22-3.91-1.21-1.77-3.1-2.01-3.77-2.04-1.6-.16-3.13.94-3.94.94-.81 0-2.07-.92-3.4-.9-1.75.03-3.36 1.02-4.26 2.58-1.82 3.16-.47 7.83 1.3 10.39.86 1.25 1.89 2.66 3.24 2.61 1.3-.05 1.79-.84 3.36-.84 1.57 0 2.01.84 3.39.81 1.4-.02 2.29-1.28 3.15-2.54.99-1.45 1.4-2.86 1.42-2.93-.03-.01-2.73-1.05-2.75-4.17zM14.6 4.59c.72-.87 1.2-2.08 1.07-3.29-1.03.04-2.28.69-3.02 1.56-.67.77-1.25 2-.1 3.17 1.13.09 2.33-.57 3.05-1.44z"/></svg>
            Continue with Apple
          </button>
        )}

        <div className="login-alt-hint">Already have an account?</div>
        <Link className="login-alt-btn" to="/login" data-testid="signup-go-login">
          Sign in instead
        </Link>
      </div>
    </div>
  );
};

export default SignupPage;
